// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2VVZj","title":"Images45_title__fhT-e","images":"Images45_images__1Tm8J"};